import * as Yup from "yup";

export const BullionConfigValidationSchema = Yup.object().shape({
  type: Yup.string().required("Type is required"),
  unit: Yup.string().required("Unit is required"),
  customer_max_buy: Yup.number()
    .required("Max buy limit is required")
    .positive(),
  customer_max_sell: Yup.number()
    .required("Max sell limit is required")
    .positive(),
  buy_price_percentage_deviation: Yup.number()
    .required("Buy price percentage deviation is required")
    .positive(),
  sell_price_percentage_deviation: Yup.number()
    .required("Sell price percentage deviation is required")
    .positive(),
  exchange_price_percentage_deviation: Yup.number()
    .required("Exchange price percentage deviation is required")
    .positive(),
  threshold_buy: Yup.number().required("Buy threshold is required").positive(),
  threshold_sell: Yup.number()
    .required("Sell threshold is required")
    .positive(),
});
